import { render, staticRenderFns } from "./StatsPage.vue?vue&type=template&id=3ccfc537&"
import script from "./StatsPage.vue?vue&type=script&lang=js&"
export * from "./StatsPage.vue?vue&type=script&lang=js&"
import style0 from "./StatsPage.vue?vue&type=style&index=0&id=3ccfc537&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports